import { ROUTE_BILL_DETAILS, ROUTE_HOMEPAGE } from '@1bill-app/constants';
import { BillQuery } from '@1bill-app/services/bill/bill.query';
import { BillService } from '@1bill-app/services/bill/bill.service';
import { ViewBillType } from '@1bill-app/services/bill/types';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-latest-bills',
  templateUrl: './latest-bills.component.html',
  styleUrls: ['./latest-bills.component.scss'],
})
export class LatestBillsComponent implements OnInit {
  public overdueBills$ = this.billQuery.overdueBills$;
  constructor(
    private billQuery: BillQuery,
    private router: Router,
    private logger: NGXLogger,
    private billService: BillService,
  ) {}

  ngOnInit() {}

  onPayNowClick(bill: ViewBillType) {
    this.logger.debug('Pay now button clicked for bill: ', bill);
    this.billService.presentPaymentCombinedModal(bill);
  }

  navigateToBillPage(billPaymentId?: number, jobId?: number) {
    if (billPaymentId)
      this.router.navigate([ROUTE_BILL_DETAILS], {
        queryParams: { _source: ROUTE_HOMEPAGE, billPaymentId: billPaymentId },
      });
    else
      this.router.navigate([ROUTE_BILL_DETAILS], {
        queryParams: { _source: ROUTE_HOMEPAGE, jobId: jobId },
      });
  }

  trackByFn(item: ViewBillType) {
    return item?.billPaymentId;
  }
}
